export const en = {
    'call-already-exists-error': 'The call for the meeting already exists',
};
